import {connect} from 'react-redux';
import {lockSelectedFeatureType, LockSelectedFeatureType} from "../../../actions/actions";
import * as React from "react";
import * as selectors from "../selectors";
import {DisplayFeatureType} from "../domain";
import classNames = require("classnames");
import FeaturesState from "../domain/FeaturesState";


interface ComponentState {
}

interface TagProps {

}

interface StateProps {
    featureType: DisplayFeatureType,
    canToggleLock: boolean,
}

interface DispatchProps {
    doLockSelectedFeatureType: LockSelectedFeatureType
}

const mapStateToProps = (state: FeaturesState) => {
    return {
        featureType: selectors.selectedFeatureType(state),
        canToggleLock: selectors.userCanToggleFeatureTypeLock(state),
    };
};

const mapDispatchToProps = ({
    doLockSelectedFeatureType: lockSelectedFeatureType
});

type Props = TagProps & StateProps & DispatchProps;

class FeatureTypeLockComponent extends React.Component<Props, ComponentState> {
    render() {
        let {featureType, canToggleLock} = this.props;

        let lockClasses = classNames({
            "fas fa-unlock-alt": !featureType.isLocked,
            "fas fa-lock": featureType.isLocked,
            "feature-lock": true,
            "locked": featureType.isLocked
        });

        if (!canToggleLock && !featureType.isLocked) {
            return null;
        }

        return (
            <button className="featureTypeLockButton" title="Låste vegobjekt-typer kan ikke redigeres"
                    onClick={() => this.toggleFeaturetypeLock()} disabled={!canToggleLock}><i className={lockClasses}/>
            </button>
        );
    }

    toggleFeaturetypeLock() {
        let {doLockSelectedFeatureType, featureType, canToggleLock} = this.props;
        if (!canToggleLock) return;
        doLockSelectedFeatureType(!featureType.isLocked);
    }
}

export const FeatureTypeLock = connect(mapStateToProps, mapDispatchToProps)(FeatureTypeLockComponent);
